export const {
  NODE_ENV,
  REACT_APP_SENTRY_ENV: SENTRY_ENV,
  REACT_APP_API_URL: API_URL,
  REACT_APP_BASENAME: BASENAME,
  REACT_APP_API_SOCKET_URL: API_SOCKET_URL,
  REACT_APP_CLIENT_APP_URL: CLIENT_APP_URL
} = process.env
